<template>
  <v-list-item dense>
    <v-list-item-content>
      <v-list-item-title v-if="diff.title" v-text="diff.title" />
      <v-list-item-subtitle>
        <template v-for="change in diff.changes">
          <diff-item
            v-if="typeof change.value !== 'object'"
            :key="`${change.context}-${change.type}-${change.value}`"
            :change="change"
            class="d-flex align-center"
          />
          <template v-else>
            <diff-item
              v-for="(val, country) in change.value"
              :key="`${country}-${change.key}-${change.type}-${change.value}`"
              :change="buildChangeObject(change, val)"
            />
          </template>
        </template>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import DiffItem from '@/components/object-diff/diff-item'
import { mapGetters } from 'vuex'

export default {
  name: 'DiffValue',
  components: {
    DiffItem,
  },
  props: {
    diff: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapGetters('options', ['formattedOption']),
    buildChangeObject({ context, type }, value) {
      return {
        context,
        type,
        value,
      }
    },
  },
}
</script>
